import Vue from 'vue'
import ReviewsList from '@/components/ProductPage/ReviewsList'
import ProductRating from '@/components/ProductPage/ProductRating'
import AddProductReviewModal from '@/components/AddProductReviewForm/AddProductReviewModal.vue'
import { GetProductPageConfig } from '@/config'
import { renderWishlist } from '@/modules/wishlist'
// import { generateLdJson } from '@/productReviews/richData'
import { ready, createComponent } from '@/shared'

// function createLdJsonElement (json) {
//   const ldJsonElement = document.createElement('script')
//   ldJsonElement.innerHTML = JSON.stringify(json)
//   ldJsonElement.type = 'application/ld+json'
//   document.head.appendChild(ldJsonElement)
// }

ready(function () {
  renderWishlist()

  const config = GetProductPageConfig()
  // const generateRichData = (reviews) => {
  //   createLdJsonElement(generateLdJson(window.dbsRichDataProductLdJson || {}, reviews, config.productName))
  // }

  const onReviewsLoaded = (reviewsData) => {
    createComponent(
      document.querySelector('#js-dbs-products-reviews--product-rating'),
      ProductRating,
      {rating: reviewsData.rating, ratingsCount: reviewsData.reviewsCount}
    )
    // if (reviewsData.reviews.length > 0) {
    //   generateRichData(reviewsData.reviews)
    // }
  }

  createComponent(
    document.querySelector('#js-dbs-products-reivews--add-review-form'),
    AddProductReviewModal
  )

  new Vue({ // eslint-disable-line no-new
    el: '#js-dbs-products-reviews--product-reviews',
    components: {
      ReviewsList
    },

    render: h => h('ReviewsList', {
      props: {
        product: {
          id: config.productId,
          name: config.productName,
          manufacturer: config.productManufacturer,
          picture: config.productPicture,
          description: config.productDescription
        }
      },
      on: {
        'reviews:loaded': onReviewsLoaded
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/product-reviews.js